export default __webpack_public_path__ + "static/media/government.22bc849f.jpg";